"use client";

import clsx from "clsx";

import useCart from "@/lib/hooks/useCart";
import Modal from "../Modal";
import CartContent from "./CartContent";
import CartHeader from "./CartHeader";
import { CartTrigger } from "./CartTrigger";
import styles from "./cart.module.css";

export interface CartTriggerProps {
  styles: string;
  activeStyles: string;
  onClick?: () => void;
}

const Cart = (cartTriggerProps: CartTriggerProps) => {
  const { modal } = useCart();

  const toggleModal = () => {
    if (modal.isOpen) {
      //   eventViewCart({
      //     currency: currency || "",
      //     items: items.map((item) => convertCartToGTagItem(item)),
      //     value: cart.summary?.prices.totalAsNumber
      //   });
    }
    modal.toggleModal();
  };

  return (
    <div>
      <CartTrigger {...cartTriggerProps} onClick={toggleModal} />

      <Modal
        isOpen={modal.isOpen}
        callback={modal.closeModal}
        className={styles["cart-modal"]}
      >
        <div className={clsx(styles["cart-dialog"])}>
          <CartHeader />

          <CartContent />
        </div>
      </Modal>
    </div>
  );
};

export default Cart;
